export const DEFAULT_DECIMAL_PLACES = 2;
